<template>
  <div>
    <div class="container" v-bind:style="width >=1023 && width <=1027 ? 'padding:0' : ''">
      <div class="row ">
        <div class="col-md-6 container-paddingt pl-0 pl-lg-3">
          <h1 class="title roboto-style dark-grey mb-3">Our vision</h1>
          <p class="description lighter-grey inter-style mb-0">Is to be a one-stop business partner for enterprises, who offers a tailored, personalized approach to any technical problem and delivers exceptional quality thanks to careful monitoring, experience, and talent. We also strive to make a safer world digitally-wise. This is why we foster cybersecurity best practices and events in the industry by providing support, sponsorship, and training.</p>
        </div>
        <div class="col-md-6 container-paddingt pl-0 pl-md-3 pl-lg-3">
          <h1 class="title roboto-style dark-grey mb-3">Our mission</h1>
          <p class="description lighter-grey inter-style xs_marginb">Well-written, scalable, and secure code, business-friendly processes delivered by top talents with the best technical expertise.</p>
        </div>
      </div>
    </div>
    <div v-if="width >= 768" class="container" style="padding-top: 50px; padding-bottom: 50px;">
      <icons_row></icons_row>
    </div>
    <div class="black-container white row container-paddingt container-paddingb">
      <div class="container">
        <div class="row" id="company_ol">
          <div class="col-lg-6 col-md-12 col-12 roboto-style">
            <p class="title">Our principles guide everything we do</p>
          </div>
          <div class="col-lg-6 col-md-12 inter-style mt-3">
            <ol >
              <li><p class=" description mb-1"> Always deliver according to the highest standards</p>
                <p class="small-description light-grey col-md-12 pl-0">Committed to innovation in technology and excellence, we help organizations attain and surpass their business objectives in terms of software solutions.</p>
              </li>
              <li>
                <p class="description mb-1 mt-4">On-time and in the shortest time</p>
                <p class="small-description light-grey col-md-12 pl-0">We work fast to help you save time and money.</p>
              </li>
              <li>
                <p class="description mb-1 mt-4">Always with security in mind</p>
                <p class="small-description light-grey col-md-12 pl-0">Unfortunately, security is regarded as a value add-on feature rather than as a core one. At Unknown Software, security is embedded in everything we do, and we place it at the heart of all our products to mitigate risks and prevent attacks.</p>
              </li>
              <li>
                <p class="description mb-1 mt-4">And full transparency </p>
                <p class="small-description light-grey col-md-12 pl-0">You have full access to your project/product at any step of the implementation process.</p>
              </li>
              <li>
                <p class="description mb-1 mt-4">Giving back</p>
                <p class="small-description light-grey col-md-12 pl-0">We believe in the power of technology to improve the lives of people and societies as a whole. Having this principle at the heart of our business, we are involved in the sponsorship of numerous events, workshops on cybersecurity and also do pro bono work - for example, creating a platform for the biggest Red Cross event in Romania.</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="container container-paddingt mb-5" v-bind:style="width >=1023 && width <=1027 ? 'padding-left:0;padding-right:0;' : ''">
      <div class="row">
        <div class="col-lg-6 col-md-12 px-0 px-lg-3" v-bind:style="width > 768 ? 'max-width: 48.8%!important;' : ''">
          <h1 class="title dark-grey roboto-style">Our core team...</h1>
          <p class="description medium-grey inter-style" style="padding-right: 30px">At the heart of our smart and unique software solutions stays our highly qualified core team with years of industry experience backing them. We have on board some of the minds with the greatest thirst for challenges in the industry today.</p>
          <p v-bind:class="['description dark-grey roboto-style xs_margint xs_marginb', {'mt-5' : width > 1023}]">...has been part of</p>
          <div class="row container-fluid px-0 mx-0">
            <div v-bind:class="['col-lg-3 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
            <div v-bind:class="['col-lg-3 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
            <div v-bind:class="['col-lg-3 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width < 576}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
            <div v-bind:class="[' col-lg-3 col-sm-4 d-flex align-items-center col-6 justify-content-center', {'mt-4' : width < 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
            <div v-bind:class="['col-lg-3 col-sm-4 col-6 d-flex align-items-center mt-4', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="ferrero-logo" src=".././assets/ferrero.png"/></div>
            <div class="col-lg-3 col-sm-4 col-6 d-flex align-items-center mt-4 justify-content-center"><img class="cocacola-logo" src=".././assets/coca-cola.png"/></div>
            <div v-bind:class="['col-lg-3 col-sm-4 col-6 d-flex align-items-center mt-4', {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="carlsberg-logo" src=".././assets/carlsberg.png"/></div>
            <div class="col-lg-3 col-sm-4 d-flex align-items-center col-6 mt-4 justify-content-center"><img class="unilever-logo" src=".././assets/unilever.png"/></div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 xs_margint" id="greycontainer" v-bind:style="width > 768 ? 'max-width: 51.2%!important;flex: 0 0 51.2%!important;' : ''">
          <div class="row" v-bind:style="width > 768 ? 'padding-top: 25%' : 'padding-top: 2%'">
            <div class="col-md-6 pl-lg-3">
              <p class="description dark-grey roboto-style mt-2 mb-3">...has expertise used</p>
              <ul class="inter-style small-description medium-grey px-0" style="list-style-type: none">
                <li class="mb-3">· Web</li>
                <li class="mb-3">· Mobile</li>
                <li class="mb-3">· Artificial Intelligence</li>
                <li class="mb-3">· UI/UX</li>
                <li class="mb-3">· DevOps</li>
                <li class="mb-3">· IoT</li>
                <li class="mb-3">· Blockchain</li>
                <li class="mb-3">· Big Data & Analytics</li>
                <li class="mb-3">· Software Architecture</li>
              </ul>
            </div>
            <div class="col-md-6 pl-lg-4">
              <p class="description dark-grey roboto-style mt-2 mb-3">...has experience in</p>
              <ul class="inter-style small-description medium-grey px-0" style="list-style-type: none">
                <li class="mb-3">· Insurtech & Health</li>
                <li class="mb-3">· Travel</li>
                <li class="mb-3">· Food</li>
                <li class="mb-3">· Mobility & Logistics</li>
                <li class="mb-3">· Media & Entertainment</li>
                <li class="mb-3">· Real Estate</li>
                <li class="mb-3">· Fintech</li>
                <li class="mb-3">· Deep Tech</li>
                <li class="mb-3">· Biotech</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container container-paddingt container-paddingb" v-bind:style="width >=1023 && width <=1027 ? 'padding-left:0;padding-right:0;' : ''">
      <div class="row">
        <div class="col-lg-6 col-md-12 pl-0 pl-lg-3">
          <h1 class="title roboto-style dark-grey">Leadership</h1>
          <p class="description medium-grey inter-style xs_marginb">Our Leadership team comprises of problem solvers and complex thinkers, passionate about new technologies and the technical field.</p>
        </div>
      </div>
      <div v-bind:class="['row', {'mt-4' : width >1023}]">
        <div class="col-lg-3 col-md-12 col-12 pl-0 pl-lg-3" v-bind:style="width >= 768? 'margin-top: 20px' : ''">
          <div v-if="width >= 1024" class="col-3 col-md-6 col-lg-12 px-0"><img class="img-fluid"  src="../assets/irimia.png"/></div>
          <div class="row">
            <div class="col-9 col-md-9 col-lg-12">
              <p class="description dark-grey roboto-style mb-0 mt-3">Irimia</p>
              <p class="small-description dark-grey inter-style font-weight-normal">CEO</p>
              <p v-if="width >= 768" class="small-description inter-style medium-grey">The great advantage of not having had the technical resources during his youth made him invent, hack, and try everything related to technology. His greatest lesson is never to give up, and this skill made him who he is today. Armed with creativity, Six Sigma Yellow Belt Certification, and lots of experience working with enterprises, he is your man if you’re striving for the impossible. </p>
            </div>
            <div v-if="width < 1024" class="col-3 col-md-3 col-lg-12 px-0"> <span class="helper"></span><img class="img-fluid" style="max-height: 200px"  src="../assets/irimia.png"/></div>
          </div>
          <div v-if="width < 768" class="row mt-4">
            <p class="small-description inter-style medium-grey col-12 xs_marginb">The great advantage of not having had the technical resources during his youth made him invent, hack, and try everything related to technology. His greatest lesson is never to give up, and this skill made him who he is today. Armed with creativity, Six Sigma Yellow Belt Certification, and lots of experience working with enterprises, he is your man if you’re striving for the impossible.  </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-12 pl-0 pl-lg-3" v-bind:style="width >= 768? 'margin-top: 20px' : ''">
          <div v-if="width >= 1024" class="col-6 col-lg-12 px-0"><img class="img-fluid" src="../assets/dan.png"/></div>
          <div class="row">
            <div class="col-9 col-md-9 col-lg-12">
            <p class="description dark-grey roboto-style mb-0 mt-3">Dan</p>
            <p class="small-description dark-grey inter-style font-weight-normal">Head of Development</p>
            <p v-if="width >= 768" class="small-description inter-style medium-grey">With over a decade of experience in the back-end, Dan is the leader of our teams of software developers, supporting them in building innovative software solutions that meet your business’s objectives. He is the man responsible for the quality and the technical approach, ensuring it is in line with the company strategy and that we deliver projects on time and on budget.
            </p>
            </div>
            <div v-if="width < 1024" class="col-3 col-md-3 col-lg-12 px-0"> <span class="helper"></span><img class="img-fluid" style="max-height: 200px" src="../assets/dan.png"/></div>
          </div>
          <div v-if="width < 768" class="row mt-4">
            <p class="small-description inter-style medium-grey col-12 xs_marginb">With over a decade of experience in the back-end, Dan is the leader of our teams of software developers, supporting them in building innovative software solutions that meet your business’s objectives. He is the man responsible for the quality and the technical approach, ensuring it is in line with the company strategy and that we deliver projects on time and on budget.  </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-12 pl-0 pl-lg-3" v-bind:style="width >= 768? 'margin-top: 20px' : ''">
          <div v-if="width >= 1024" class="col-6 col-lg-12 px-0"><img class="img-fluid" src="../assets/felicia.png"/></div>
          <div class="row">
            <div class="col-9 col-md-9 col-lg-12">
            <p class="description dark-grey roboto-style mb-0 mt-3">Felicia</p>
            <p class="small-description dark-grey inter-style font-weight-normal">Head of Growth and Marketing</p>
            <p v-if="width >= 768" class="small-description inter-style medium-grey">With a head for entrepreneurship, spectacular sales skills, and a deep understanding of business needs, Felicia is the one responsible for our and your company’s success, assuring revenue growth through strategically driven leads and making sure we attain or even surpass our goals. </p>
            </div>
            <div v-if="width < 1024" class="col-3 col-md-3 col-lg-12 px-0"> <span class="helper"></span><img class="img-fluid" style="max-height: 200px" src="../assets/felicia.png"/></div>
          </div>
          <div v-if="width < 768" class="row mt-4">
              <p class="small-description inter-style medium-grey col-12 xs_marginb">With a head for entrepreneurship, spectacular sales skills, and a deep understanding of business needs, Felicia is the one responsible for our and your company’s success, assuring revenue growth through strategically driven leads and making sure we attain or even surpass our goals. </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-12 pl-0 pl-lg-3" v-bind:style="width >= 768? 'margin-top: 20px' : ''">
          <div v-if="width >= 1024" class="col-6 col-lg-12 px-0"><img class="img-fluid" src="../assets/adrian.png"/></div>
          <div class="row">
            <div class="col-9 col-md-9 col-lg-12">
            <p class="description dark-grey roboto-style mb-0 mt-3">Adrian</p>
            <p class="small-description dark-grey inter-style font-weight-normal">Head of Project Management</p>
            <p v-if="width >= 768" class="small-description inter-style medium-grey">He is the one who will make sure that we employ only the best practices in the communication and support process throughout the development of your product. He is running the project management department, coordinating our teams and making sure that nothing gets lost in translation between us.   </p>
          </div>
          <div v-if="width < 1024" class="col-3 col-md-3 col-lg-12 px-0"><span class="helper"></span><img class="img-fluid" style="max-height: 200px" src="../assets/adrian.png"/></div>
          </div>
          <div v-if="width < 768" class="row mt-4">
            <p class="small-description inter-style medium-grey col-12 xs_marginb">He is the one who will make sure that we employ only the best practices in the communication and support process throughout the development of your product. He is running the project management department, coordinating our teams and making sure that nothing gets lost in translation between us.  </p>
          </div>
        </div>
      </div>
    </div>
    <div id="world-container" class="container">
      <div class="row mb-3">
        <div class="col-lg-6 col-md-12 pl-lg-3 pl-0" v-bind:style="width >= 1025 ? 'padding-left: 30px!important' : ''"><h1 class="roboto-style title dark-grey">We cover 2 continents and multiple timezones</h1></div>
      </div>
      <div class="row"><div class="col-lg-6 col-md-12 pl-lg-3 pl-0 xs_marginb" v-bind:style="width >= 1025 ? 'padding-left: 30px!important' : ''"><p class="inter-style description medium-grey">Which are based on years of experience in multiple industries and deep understanding of business needs.</p></div></div>
      <div v-bind:class="['row xs_marginb', {'mt-5 mb-5' : width > 1023}]">
        <div class="col-lg-3 col-md-3 col-6 pl-lg-3 px-0" v-bind:style="width >= 1025 ? 'padding-left: 30px!important' : ''">
              <div class="row">
                <div class="col-lg-3 col-md-5 col-6"><clock></clock></div>
                <div class="col-lg-7 col-md-6 col-6 position-relative px-0 ml-lg-2"> <p class="description dark-grey roboto-style position-absolute" v-bind:style="width <= 992 ? 'bottom: 5px; left: 0;' : 'bottom: 5px; left: 10px'">San Francisco</p></div>
              </div>
        </div>
        <div class="col-lg-3 col-md-3 col-6 pl-lg-3 px-0">
          <div class="row">
            <div class="col-lg-3 col-md-5 col-6"><clock></clock></div>
            <div class="col-lg-7 col-md-6 col-6 position-relative px-0 ml-lg-2"> <p class="description dark-grey roboto-style position-absolute" v-bind:style="width <= 992 ? 'bottom: 5px; left: 0' : 'bottom: 5px; left: 10px'">New York</p></div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-6 mt-lg-0 pl-lg-3 px-0" v-bind:style="width < 768 ? 'margin-top: 30px; margin-bottom: 10px' : ''">
          <div class="row">
            <div class="col-lg-3 col-md-5 col-6"><clock></clock></div>
            <div class=" col-lg-7 col-md-6 col-6 position-relative px-0 ml-lg-2"> <p class="description dark-grey roboto-style position-absolute" v-bind:style="width <= 992 ? 'bottom: 5px; left: 0' : 'bottom: 5px; left: 10px'">London</p></div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-6 mt-lg-0 px-0" v-bind:style="width < 768 ? 'margin-top: 30px; margin-bottom: 10px' : ''">
          <div class="row">
            <div class="col-lg-3 col-md-5 col-6"><clock></clock></div>
            <div class="col-lg-7 col-md-6 col-6 position-relative px-0 ml-lg-2"> <p class="description dark-grey roboto-style position-absolute" v-bind:style="width <= 992 ? 'bottom: 5px; left: 0' : 'bottom: 5px; left: 10px'">Berlin</p></div>
          </div>
        </div>
      </div>
    </div>
<conversation></conversation>
  </div>
</template>

<script>
    import icons_row from './icons_row';
    import clock from './clock';
    import conversation from './conversation';
    export default {
        components: {
            icons_row,
            clock,
            conversation
        },
        data() {
            return {
                width: 0
            }
        },
        computed: {
            windowWidth: {
                get: function () {
                    return this.width;
                },
                set: function (val) {
                    this.width = val;
                }

            }
        },
        mounted() {
            this.width = window.innerWidth;
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/company.vue